import styled from 'styled-components'

export const DisplayContainer = styled.div`
  display: inline;
`

